import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SendTestMessageModalComponent } from '../../../../../../components/forms/send-test-message-modal/send-test-message-modal.component';
import { IContact, IOrganization, ITag } from '../../../../../../types/contactModule';
import { IEntitySegmentQuery } from '../../../../../../components/organization/segments/segment-utilities';
import { SmsBubbleComponent } from '../../../../../../components/messages/sms-bubble/sms-bubble.component';
import { describeChar, formatCount, smsParts, SmsParts } from '../../../../../../../utils/sms';
import { ScheduleSummary } from '../../compose-schedule';

/**
 * The pre-send review: who gets it once duplicates are removed, what it
 * costs, when it goes out, and the message as a phone shows it. The page
 * owns the recipient count and passes it in.
 */
@Component({
  selector: 'preview-message-details',
  standalone: true,
  imports: [SendTestMessageModalComponent, SmsBubbleComponent],
  templateUrl: './preview-message-details.component.html',
  styleUrl: './preview-message-details.component.css',
})
export class PreviewMessageDetailsComponent {
  @Input() messageSubject: string = '';
  @Input() senderID: string = '';
  @Input() messageBody: string = '';
  @Input() phoneNumbers: string[] = [];
  @Input() selectedContacts: IContact[] = [];
  @Input() selectedTags: ITag[] = [];
  @Input() selectedSegments: IEntitySegmentQuery[] = [];
  @Input() selectedOrganizations: IOrganization[] = [];

  /** Deduplicated recipients from the server; null until counted. */
  @Input() recipientCount: number | null = null;
  @Input() isFetchingCount: boolean = false;
  @Input() countError: string = '';
  @Input() countApprox: boolean = false;
  /** "3 numbers, 2 tags and 1 file". */
  @Input() breakdown: string = '';
  @Input() parts: SmsParts = smsParts('');
  @Input() estimatedSms: number | null = null;
  @Input() scheduled: boolean = false;
  @Input() schedule: ScheduleSummary | null = null;

  @Output() backToWritingEvent = new EventEmitter();
  @Output() retryCount = new EventEmitter<void>();

  formatCount = formatCount;

  showTestMessageModal: boolean = false;

  get partsLabel(): string {
    const parts = this.parts.parts;
    return parts === 1 ? '1 part' : `${parts} parts`;
  }

  get encodingLabel(): string {
    const { encoding, offender } = this.parts;
    if (encoding !== 'Unicode') return 'GSM-7';
    return offender ? `Unicode, because of ${describeChar(offender)}` : 'Unicode';
  }

  openTestMessageModal() {
    this.showTestMessageModal = true;
  }
  closeTestMessageModal() {
    this.showTestMessageModal = false;
  }

  goBackToWriting() {
    this.backToWritingEvent.emit();
  }
}
